import API from '../../../../services/API';

export default function getPaymentRequisitesByOktmo(oktmo) {
  return API.request({
    method: 'GET',
    url: `/taxAuthority/receiver-requisites?oktmo=${oktmo}`,
  });
}
